import {createContext} from 'react'

import type {DirectoryItem} from '@github-ui/code-view-types'
import type {TreeItem} from '@github-ui/repos-file-tree-view'

export type FolderContents = {items: Array<TreeItem<DirectoryItem>>; totalCount: number}

export type KnownFoldersValue = {
  folders: ReadonlyMap<string, FolderContents>
  setFolder: (path: string, items: Array<TreeItem<DirectoryItem>>, totalCount: number) => void
}

const EMPTY_FOLDERS: ReadonlyMap<string, FolderContents> = new Map()

// Default value used when no provider is present — keeps the tree functional in tests and isolated mounts.
export const KnownFoldersContext = createContext<KnownFoldersValue>({
  folders: EMPTY_FOLDERS,
  setFolder: () => {},
})

/** Returns the freshest known items for `directory`, falling back to the prop tree when nothing newer is cached. */
export function resolveDirectoryItems(
  directory: TreeItem<DirectoryItem>,
  folders: ReadonlyMap<string, FolderContents>,
): Array<TreeItem<DirectoryItem>> {
  return folders.get(directory.data.path)?.items ?? directory.items
}

/** Returns the freshest known total count for `directory`, falling back to the prop value. */
export function resolveTotalCount(
  directory: TreeItem<DirectoryItem>,
  folders: ReadonlyMap<string, FolderContents>,
): number {
  return folders.get(directory.data.path)?.totalCount ?? directory.data.totalCount ?? 0
}
